<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Bảo trì & Sửa chữa', href: '/facility/maintenance' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn v-if="!isTeacher" outlined color="indigo" class="mr-2" @click="scheduleDialog = !scheduleDialog">
          <v-icon left>mdi-calendar-plus</v-icon> Thêm lịch bảo dưỡng
        </v-btn>
        <v-btn depressed dark color="primary" @click="repairDialog = !repairDialog">
          <v-icon left>mdi-plus</v-icon> Báo hỏng thiết bị
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <MaintenanceFilter @onFilterChanged="onFilterChange" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <MaintenanceDataTable ref="maintenanceDataTable" />
    </v-card>

    <RepairNewDialog :state="repairDialog" @updated="onFilterChange()" />
    <ScheduleNewDialog v-if="!isTeacher" :state="scheduleDialog" @updated="onFilterChange()" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import MaintenanceDataTable from '@/modules/facility/maintenance/MaintenanceDataTable.vue'
import MaintenanceFilter from '@/modules/facility/maintenance/MaintenanceFilter.vue'

export default {
  name: 'FacilityMaintenance',
  components: {
    Breadcrumbs,
    MaintenanceDataTable,
    MaintenanceFilter,
    RepairNewDialog: () => import('@/modules/facility/maintenance/RepairNewDialog.vue'),
    ScheduleNewDialog: () => import('@/modules/facility/maintenance/ScheduleNewDialog.vue')
  },
  data() {
    return {
      repairDialog: false,
      scheduleDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['role']),
    isTeacher() {
      return this.role && this.role.name === 'Teacher'
    }
  },
  methods: {
    async refresh(query) {
      this.$refs.maintenanceDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    }
  }
}
</script>
